module.exports = __webpack_public_path__ + "img/border_triangle.81225604.svg";